// import "./new.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Select from "react-select";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Button from "@mui/material/Button";
// import Box from "@mui/material/Box";
// import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import Typography from "@mui/material/Typography";
// import Grid from "@mui/material/Grid";

// const theme = createTheme({
//   palette: {
//     primary: { main: "#7451f8" },
//     secondary: { main: "#6c757d" },
//   },
// });

// const VisuallyHiddenInput = styled("input")({
//   clip: "rect(0 0 0 0)",
//   clipPath: "inset(50%)",
//   height: 1,
//   overflow: "hidden",
//   position: "absolute",
//   bottom: 0,
//   left: 0,
//   whiteSpace: "nowrap",
//   width: 1,
// });

// const FilePreviewContainer = styled("div")({
//   position: "relative",
//   width: "100%",
//   height: 200,
//   borderRadius: 12,
//   border: "2px dashed #e0e0e0",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center",
//   backgroundColor: "#fafafa",
//   marginBottom: 20,
//   overflow: "hidden",
//   transition: "all 0.3s ease",
//   "&.drag-active": {
//     borderColor: "#7451f8",
//     backgroundColor: "rgba(116, 81, 248, 0.05)",
//   },
// });

// const PreviewImage = styled("img")({
//   maxWidth: "100%",
//   maxHeight: "100%",
//   objectFit: "contain",
// });

// const FileInfo = styled("div")({
//   marginTop: 10,
//   textAlign: "center",
//   "& .fileName": {
//     fontWeight: 500,
//     color: "#333",
//     fontSize: 14,
//     marginTop: 8,
//     wordBreak: "break-all",
//     padding: "0 10px",
//   },
//   "& .fileSize": { color: "#757575", fontSize: 12 },
// });

// const RemoveButton = styled(Button)({
//   position: "absolute",
//   top: 8,
//   right: 8,
//   minWidth: 30,
//   height: 30,
//   borderRadius: "50%",
//   padding: 0,
// });

// const StyledSelect = styled(Select)({
//   width: "100%",
//   "& .select__control": {
//     minHeight: 46,
//     border: "1px solid #e2e8f0",
//     borderRadius: 6,
//     backgroundColor: "#f8fafc",
//     transition: "all 0.3s ease",
//     "&:hover": { borderColor: "#cbd5e0" },
//   },
//   "& .select__control--is-focused": {
//     borderColor: "#7451f8",
//     boxShadow: "0 0 0 3px rgba(116, 81, 248, 0.15)",
//     backgroundColor: "white",
//   },
//   "& .select__value-container": { padding: "2px 8px" },
//   "& .select__indicator": { padding: "8px" },
// });

// const AmountTypeOptions = [
//   { value: "fee", label: "Fee" },
//   { value: "fine", label: "Fine" },
// ];

// const StatusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];

// const FeesFormNew = ({ title }) => {
//   const [file, setFile] = useState(null);
//   const [filePreview, setFilePreview] = useState("");
//   const [dragActive, setDragActive] = useState(false);
//   const [inputValues, setInputValues] = useState({
//     amount_type: "",
//     student_id: null,
//     selectedStudents: [],
//     selectedMonths: [],
//     amount: "",
//     user_id: null,
//     account_id: null,
//     description: "",
//     date: "",
//     status: 1,
//   });
//   const [filteredStudentOptions, setFilteredStudentOptions] = useState([]);
//   const [userOptions, setUserOptions] = useState([]);
//   const [accountOptions, setAccountOptions] = useState([]);
//   const [isLoadingStudents, setIsLoadingStudents] = useState(false);

//   const center_id = localStorage.getItem("center_id");
//   const [token] = useState(localStorage.getItem("token"));
//   const navigate = useNavigate();

//   const redirectToLogin = () => {
//     toast.warning("Please login first to access this page", {
//       autoClose: 2000,
//       onClose: () => (window.location.href = "/"),
//     });
//   };

//   const handleDrag = useCallback((e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragActive(e.type === "dragenter" || e.type === "dragover");
//   }, []);

//   const handleDrop = useCallback((e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragActive(false);
//     if (e.dataTransfer.files && e.dataTransfer.files[0])
//       processFile(e.dataTransfer.files[0]);
//   }, []);

//   const processFile = (selectedFile) => {
//     if (!selectedFile) return;
//     const validTypes = ["image/jpeg", "image/png", "application/pdf"];
//     if (!validTypes.includes(selectedFile.type))
//       return toast.error("Please upload an image (JPG/PNG) or PDF file");
//     if (selectedFile.size > 5 * 1024 * 1024)
//       return toast.error("File size exceeds 5MB limit");

//     setFile(selectedFile);
//     if (selectedFile.type === "application/pdf")
//       setFilePreview("/images/pdf_icon.png");
//     else {
//       const reader = new FileReader();
//       reader.onload = (e) => setFilePreview(e.target.result);
//       reader.readAsDataURL(selectedFile);
//     }
//   };

//   const handleFileChange = (e) => {
//     if (e.target.files && e.target.files[0]) processFile(e.target.files[0]);
//   };
//   const handleRemoveFile = () => {
//     setFile(null);
//     setFilePreview("");
//   };

//   const handleAmountTypeSelectChange = async (selectedOption) => {
//     const newAmountType = selectedOption.value;
//     setInputValues({
//       ...inputValues,
//       amount_type: newAmountType,
//       student_id: null,
//       selectedStudents: [],
//       selectedMonths: [],
//       amount: "",
//     });
//     if (newAmountType) await fetchStudents(newAmountType);
//     else setFilteredStudentOptions([]);
//   };

//   const handleStudentSelectChange = (selectedOption) => {
//     if (inputValues.amount_type === "fee") {
//       setInputValues({
//         ...inputValues,
//         student_id: selectedOption ? selectedOption.value : null,
//         selectedStudents: selectedOption ? [selectedOption] : [],
//         selectedMonths: [],
//         amount: "",
//       });
//     } else {
//       setInputValues({
//         ...inputValues,
//         selectedStudents: selectedOption || [],
//         selectedMonths: [],
//         amount: "",
//       });
//     }
//   };

//   const handleMonthSelectChange = (selectedOption) => {
//     const amount = selectedOption.length * 500; // 500 per month
//     setInputValues((prev) => ({
//       ...prev,
//       selectedMonths: selectedOption,
//       amount: amount.toString(),
//     }));
//   };

//   const handleUserSelectChange = (selectedOption) =>
//     setInputValues({ ...inputValues, user_id: selectedOption.value });
//   const handleAccountSelectChange = (selectedOption) =>
//     setInputValues({ ...inputValues, account_id: selectedOption.value });
//   const handleStatusSelectChange = (selectedOption) =>
//     setInputValues({ ...inputValues, status: selectedOption.value });
//   const handleInputChange = (e) =>
//     setInputValues({ ...inputValues, [e.target.name]: e.target.value });

//   useEffect(() => {
//     fetchUsers();
//     fetchAccounts();
//   }, []);

//   const fetchStudents = async (amountType) => {
//     if (!amountType) return;

//     setIsLoadingStudents(true);
//     try {
//       // Only for fines, fetch students with their pending months
//       const url =
//         amountType === "fine"
//           ? `${serverUrl}/students_by_type/${center_id}/fine`
//           : `${serverUrl}/students_by_type/${center_id}/fee`;

//       const response = await fetch(url);
//       if (!response.ok) throw new Error("Failed to fetch students");
//       const data = await response.json();

//       if (amountType === "fine") {
//         // Group months by student
//         const studentMap = {};
//         data.data.forEach((item) => {
//           if (!studentMap[item.id]) {
//             studentMap[item.id] = {
//               value: item.id,
//               label: item.name,
//               pendingMonths: [],
//             };
//           }
//           studentMap[item.id].pendingMonths.push(item.month);
//         });

//         const options = Object.values(studentMap);
//         setFilteredStudentOptions(options);
//       } else {
//         // Regular fee students
//         const options = data.data.map((item) => ({
//           value: item.id,
//           label: `${item.name} - ${item.amount}`,
//         }));
//         setFilteredStudentOptions(options);
//       }
//     } catch (error) {
//       console.error("Error fetching students:", error);
//       toast.error("Failed to load students");
//       setFilteredStudentOptions([]);
//     } finally {
//       setIsLoadingStudents(false);
//     }
//   };

//   const fetchUsers = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
//       if (!response.ok) throw new Error("Failed to fetch users");
//       const data = await response.json();
//       setUserOptions(
//         data.data.map((item) => ({ value: item.id, label: item.name }))
//       );
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to load users");
//     }
//   };

//   const fetchAccounts = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/account_ids/${center_id}`);
//       if (!response.ok) throw new Error("Failed to fetch accounts");
//       const data = await response.json();
//       setAccountOptions(
//         data.data.map((item) => ({ value: item.id, label: item.name }))
//       );
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to load accounts");
//     }
//   };
//   useEffect(() => {
//     if (
//       inputValues.amount_type === "fine" &&
//       inputValues.selectedStudents.length &&
//       inputValues.selectedMonths.length
//     ) {
//       // Build a description string
//       const studentNames = inputValues.selectedStudents
//         .map((s) => s.label)
//         .join(", ");
//       const months = inputValues.selectedMonths.map((m) => m.label).join(", ");
//       const desc = `Fine submitted for ${studentNames} for ${months}`;

//       setInputValues((prev) => ({ ...prev, description: desc }));
//     }
//   }, [
//     inputValues.amount_type,
//     inputValues.selectedStudents,
//     inputValues.selectedMonths,
//   ]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!file) return toast.error("Please upload the fee slip/image");

//     const requiredFields = [
//       "user_id",
//       "account_id",
//       "amount",
//       "amount_type",
//       "description",
//       "date",
//     ];
//     if (inputValues.amount_type === "fee") requiredFields.push("student_id");
//     if (
//       inputValues.amount_type === "fine" &&
//       (!inputValues.selectedStudents.length ||
//         !inputValues.selectedMonths.length)
//     )
//       return toast.error("Select at least one student and month for fine");

//     const missingFields = requiredFields.filter((field) => !inputValues[field]);
//     if (missingFields.length)
//       return toast.error(
//         `Please fill in all required fields: ${missingFields.join(", ")}`
//       );

//     const formData = new FormData();
//     formData.append("center_id", center_id);
//     if (inputValues.amount_type === "fee")
//       formData.append("student_id", inputValues.student_id);
//     else {
//       formData.append(
//         "student_ids",
//         JSON.stringify(inputValues.selectedStudents.map((s) => s.value))
//       );
//       formData.append(
//         "months",
//         JSON.stringify(inputValues.selectedMonths.map((m) => m.value))
//       );
//     }
//     formData.append("user_id", inputValues.user_id);
//     formData.append("account_id", inputValues.account_id);
//     formData.append("amount", inputValues.amount);
//     formData.append("amount_type", inputValues.amount_type);
//     formData.append("description", inputValues.description);
//     formData.append("date", inputValues.date);
//     formData.append("status", inputValues.status || 1);
//     formData.append("logo", file);

//     const toastId = toast.loading("Adding new fee receipt...");
//     try {
//       const response = await fetch(`${serverUrl}/add_feesform`, {
//         method: "POST",
//         body: formData,
//       });
//       const data = await response.json();
//       if (data.code >= 400)
//         toast.update(toastId, {
//           render: data.message || "Failed to add fee receipt",
//           type: "error",
//           isLoading: false,
//           autoClose: 5000,
//         });
//       else {
//         toast.update(toastId, {
//           render: "Fee receipt added successfully!",
//           type: "success",
//           isLoading: false,
//           autoClose: 2000,
//         });
//         setInputValues({
//           amount_type: "",
//           student_id: null,
//           selectedStudents: [],
//           selectedMonths: [],
//           amount: "",
//           user_id: null,
//           account_id: null,
//           description: "",
//           date: "",
//           status: 1,
//         });
//         setFile(null);
//         setFilePreview("");
//         setFilteredStudentOptions([]);
//         setTimeout(() => navigate("/fees-form"), 1500);
//       }
//     } catch (error) {
//       console.log(error);
//       toast.update(toastId, {
//         render: "Error occurred while adding fee receipt",
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });
//     }
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <ToastContainer position="top-right" autoClose={3000} />
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="contentWrapper">
//               <Card className="formCard">
//                 <CardContent className="cardContent">
//                   <Typography
//                     variant="h5"
//                     component="h2"
//                     gutterBottom
//                     className="formTitle"
//                   >
//                     {title}
//                   </Typography>
//                   <form onSubmit={handleSubmit} className="responsiveForm">
//                     <Grid container spacing={2}>
//                       {/* File Upload */}
//                       <Grid item xs={12}>
//                         <FilePreviewContainer
//                           className={dragActive ? "drag-active" : ""}
//                           onDragEnter={handleDrag}
//                           onDragOver={handleDrag}
//                           onDragLeave={handleDrag}
//                           onDrop={handleDrop}
//                         >
//                           {filePreview ? (
//                             <>
//                               <PreviewImage
//                                 src={filePreview}
//                                 alt="Fee Slip Preview"
//                               />
//                               {file && (
//                                 <>
//                                   <FileInfo>
//                                     <div className="fileName">{file.name}</div>
//                                     <div className="fileSize">
//                                       {(file.size / 1024).toFixed(1)} KB
//                                     </div>
//                                   </FileInfo>
//                                   <RemoveButton
//                                     variant="contained"
//                                     color="error"
//                                     onClick={handleRemoveFile}
//                                   >
//                                     ×
//                                   </RemoveButton>
//                                 </>
//                               )}
//                             </>
//                           ) : (
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 textAlign: "center",
//                                 p: 2,
//                               }}
//                             >
//                               <CloudUploadIcon
//                                 sx={{
//                                   fontSize: 48,
//                                   color: dragActive ? "#7451f8" : "#bdbdbd",
//                                   mb: 1,
//                                   transition: "color 0.3s",
//                                 }}
//                               />
//                               <Typography variant="body1" color="textSecondary">
//                                 {dragActive
//                                   ? "Drop your fee slip here"
//                                   : "Drag & drop your fee slip here or"}
//                               </Typography>
//                               <Button
//                                 component="label"
//                                 variant="outlined"
//                                 startIcon={<DriveFolderUploadOutlinedIcon />}
//                                 sx={{ mt: 2 }}
//                               >
//                                 Browse Files
//                                 <VisuallyHiddenInput
//                                   type="file"
//                                   accept="image/*,.pdf"
//                                   onChange={handleFileChange}
//                                   required
//                                 />
//                               </Button>
//                               <Typography
//                                 variant="caption"
//                                 color="textSecondary"
//                                 sx={{ mt: 1 }}
//                               >
//                                 (Supports JPG, PNG, PDF up to 5MB)
//                               </Typography>
//                             </Box>
//                           )}
//                         </FilePreviewContainer>
//                       </Grid>

//                       {/* Amount Type */}
//                       <Grid item xs={12} sm={6}>
//                         <div className="formInput">
//                           <label>Amount Type *</label>
//                           <StyledSelect
//                             options={AmountTypeOptions}
//                             name="amount_type"
//                             onChange={handleAmountTypeSelectChange}
//                             value={
//                               AmountTypeOptions.find(
//                                 (option) =>
//                                   option.value === inputValues.amount_type
//                               ) || null
//                             }
//                             required
//                             classNamePrefix="select"
//                             placeholder="Select amount type"
//                           />
//                         </div>
//                       </Grid>

//                       {/* Student Selection */}
//                       {inputValues.amount_type && (
//                         <Grid item xs={12} sm={6}>
//                           <div className="formInput">
//                             <label>
//                               Student
//                               {inputValues.amount_type === "fine" ? "s" : ""} *
//                             </label>
//                             {isLoadingStudents ? (
//                               <div>Loading students...</div>
//                             ) : filteredStudentOptions.length > 0 ? (
//                               <StyledSelect
//                                 options={filteredStudentOptions}
//                                 name="student_id"
//                                 onChange={handleStudentSelectChange}
//                                 value={inputValues.selectedStudents}
//                                 required
//                                 classNamePrefix="select"
//                                 placeholder={`Select student${
//                                   inputValues.amount_type === "fine" ? "s" : ""
//                                 }`}
//                                 isMulti={inputValues.amount_type === "fine"}
//                               />
//                             ) : (
//                               <div>No students available for this type</div>
//                             )}
//                           </div>
//                         </Grid>
//                       )}

//                       {/* Month Selector for Fine */}
//                       {inputValues.amount_type === "fine" &&
//                         inputValues.selectedStudents.length > 0 && (
//                           <Grid item xs={12} sm={6}>
//                             <div className="formInput">
//                               <label>Select Month(s) *</label>
//                               <StyledSelect
//                                 options={inputValues.selectedStudents.flatMap(
//                                   (student) =>
//                                     student.pendingMonths.map((month) => ({
//                                       value: month,
//                                       label: month + ` (${student.label})`,
//                                     }))
//                                 )}
//                                 value={inputValues.selectedMonths}
//                                 onChange={handleMonthSelectChange}
//                                 isMulti
//                                 placeholder="Select month(s)"
//                                 classNamePrefix="select"
//                               />
//                               <Typography
//                                 variant="caption"
//                                 color="textSecondary"
//                               >
//                                 Amount is calculated as 500 per month
//                               </Typography>
//                             </div>
//                           </Grid>
//                         )}

//                       {/* User */}
//                       <Grid item xs={12} sm={6}>
//                         <div className="formInput">
//                           <label>User *</label>
//                           <StyledSelect
//                             options={userOptions}
//                             name="user_id"
//                             onChange={handleUserSelectChange}
//                             value={
//                               userOptions.find(
//                                 (option) => option.value === inputValues.user_id
//                               ) || null
//                             }
//                             required
//                             classNamePrefix="select"
//                             placeholder="Select user"
//                           />
//                         </div>
//                       </Grid>

//                       {/* Account */}
//                       <Grid item xs={12} sm={6}>
//                         <div className="formInput">
//                           <label>Account *</label>
//                           <StyledSelect
//                             options={accountOptions}
//                             name="account_id"
//                             onChange={handleAccountSelectChange}
//                             value={
//                               accountOptions.find(
//                                 (option) =>
//                                   option.value === inputValues.account_id
//                               ) || null
//                             }
//                             required
//                             classNamePrefix="select"
//                             placeholder="Select account"
//                           />
//                         </div>
//                       </Grid>

//                       {/* Amount */}
//                       <Grid item xs={12} sm={6}>
//                         <div className="formInput">
//                           <label>Amount *</label>
//                           <input
//                             type="number"
//                             name="amount"
//                             value={inputValues.amount}
//                             onChange={handleInputChange}
//                             placeholder="Enter amount"
//                             required
//                           />
//                         </div>
//                       </Grid>

//                       {/* Description */}
//                       <Grid item xs={12} sm={6}>
//                         <div className="formInput">
//                           <label>Description *</label>
//                           <input
//                             type="text"
//                             name="description"
//                             value={inputValues.description}
//                             onChange={handleInputChange}
//                             placeholder="Enter description"
//                             required
//                           />
//                         </div>
//                       </Grid>

//                       {/* Date */}
//                       <Grid item xs={12} sm={6}>
//                         <div className="formInput">
//                           <label>Date *</label>
//                           <input
//                             type="date"
//                             name="date"
//                             value={inputValues.date}
//                             onChange={handleInputChange}
//                             required
//                           />
//                         </div>
//                       </Grid>

//                       {/* Status */}
//                       {/* <Grid item xs={12} sm={6}>
//                         <div className="formInput">
//                           <label>Status *</label>
//                           <StyledSelect
//                             options={StatusOptions}
//                             name="status"
//                             onChange={handleStatusSelectChange}
//                             value={
//                               StatusOptions.find(
//                                 (option) => option.value === inputValues.status
//                               ) || StatusOptions[0]
//                             }
//                             classNamePrefix="select"
//                           />
//                         </div>
//                       </Grid> */}

//                       <Grid item xs={12}>
//                         <Button
//                           type="submit"
//                           variant="contained"
//                           color="primary"
//                           fullWidth
//                         >
//                           Submit
//                         </Button>
//                       </Grid>
//                     </Grid>
//                   </form>
//                 </CardContent>
//               </Card>
//             </div>
//           </div>
//         </div>
//       )}
//     </ThemeProvider>
//   );
// };

// export default FeesFormNew;

import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Select from "react-select";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const theme = createTheme({
  palette: {
    primary: { main: "#7451f8" },
    secondary: { main: "#6c757d" },
  },
});

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const FilePreviewContainer = styled("div")({
  position: "relative",
  width: "100%",
  height: 200,
  borderRadius: 12,
  border: "2px dashed #e0e0e0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#fafafa",
  marginBottom: 20,
  overflow: "hidden",
  transition: "all 0.3s ease",
  "&.drag-active": {
    borderColor: "#7451f8",
    backgroundColor: "rgba(116, 81, 248, 0.05)",
  },
});

const PreviewImage = styled("img")({
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
});

const FileInfo = styled("div")({
  marginTop: 10,
  textAlign: "center",
  "& .fileName": {
    fontWeight: 500,
    color: "#333",
    fontSize: 14,
    marginTop: 8,
    wordBreak: "break-all",
    padding: "0 10px",
  },
  "& .fileSize": { color: "#757575", fontSize: 12 },
});

const RemoveButton = styled(Button)({
  position: "absolute",
  top: 8,
  right: 8,
  minWidth: 30,
  height: 30,
  borderRadius: "50%",
  padding: 0,
});

const StyledSelect = styled(Select)({
  width: "100%",
  "& .select__control": {
    minHeight: 46,
    border: "1px solid #e2e8f0",
    borderRadius: 6,
    backgroundColor: "#f8fafc",
    transition: "all 0.3s ease",
    "&:hover": { borderColor: "#cbd5e0" },
  },
  "& .select__control--is-focused": {
    borderColor: "#7451f8",
    boxShadow: "0 0 0 3px rgba(116, 81, 248, 0.15)",
    backgroundColor: "white",
  },
  "& .select__value-container": { padding: "2px 8px" },
  "& .select__indicator": { padding: "8px" },
});

const AmountTypeOptions = [
  { value: "fee", label: "Fee" },
  { value: "fine", label: "Fine" },
];

const StatusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const FeesFormNew = ({ title }) => {
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState("");
  const [dragActive, setDragActive] = useState(false);
  const [inputValues, setInputValues] = useState({
    amount_type: "",
    student_id: null,
    selectedStudents: [],
    selectedMonths: [],
    amount: "",
    user_id: null,
    account_id: null,
    description: "",
    date: "",
    status: 1,
  });
  const [filteredStudentOptions, setFilteredStudentOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [isLoadingStudents, setIsLoadingStudents] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false); // State for confirmation dialog

  const center_id = localStorage.getItem("center_id");
  const [token] = useState(localStorage.getItem("token"));
  const navigate = useNavigate();

  const redirectToLogin = () => {
    toast.warning("Please login first to access this page", {
      autoClose: 2000,
      onClose: () => (window.location.href = "/"),
    });
  };

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(e.type === "dragenter" || e.type === "dragover");
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0])
      processFile(e.dataTransfer.files[0]);
  }, []);

  const processFile = (selectedFile) => {
    if (!selectedFile) return;
    const validTypes = ["image/jpeg", "image/png", "application/pdf"];
    if (!validTypes.includes(selectedFile.type))
      return toast.error("Please upload an image (JPG/PNG) or PDF file");
    if (selectedFile.size > 5 * 1024 * 1024)
      return toast.error("File size exceeds 5MB limit");

    setFile(selectedFile);
    if (selectedFile.type === "application/pdf")
      setFilePreview("/images/pdf_icon.png");
    else {
      const reader = new FileReader();
      reader.onload = (e) => setFilePreview(e.target.result);
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) processFile(e.target.files[0]);
  };
  const handleRemoveFile = () => {
    setFile(null);
    setFilePreview("");
  };

  const handleAmountTypeSelectChange = async (selectedOption) => {
    const newAmountType = selectedOption.value;
    setInputValues({
      ...inputValues,
      amount_type: newAmountType,
      student_id: null,
      selectedStudents: [],
      selectedMonths: [],
      amount: "",
    });
    if (newAmountType) await fetchStudents(newAmountType);
    else setFilteredStudentOptions([]);
  };

  const handleStudentSelectChange = (selectedOption) => {
    if (inputValues.amount_type === "fee") {
      setInputValues({
        ...inputValues,
        student_id: selectedOption ? selectedOption.value : null,
        selectedStudents: selectedOption ? [selectedOption] : [],
        selectedMonths: [],
        amount: "",
      });
    } else {
      setInputValues({
        ...inputValues,
        selectedStudents: selectedOption || [],
        selectedMonths: [],
        amount: "",
      });
    }
  };

  const handleMonthSelectChange = (selectedOption) => {
    const amount = selectedOption.length * 500; // 500 per month
    setInputValues((prev) => ({
      ...prev,
      selectedMonths: selectedOption,
      amount: amount.toString(),
    }));
  };

  const handleUserSelectChange = (selectedOption) =>
    setInputValues({ ...inputValues, user_id: selectedOption.value });
  const handleAccountSelectChange = (selectedOption) =>
    setInputValues({ ...inputValues, account_id: selectedOption.value });
  const handleStatusSelectChange = (selectedOption) =>
    setInputValues({ ...inputValues, status: selectedOption.value });
  const handleInputChange = (e) =>
    setInputValues({ ...inputValues, [e.target.name]: e.target.value });

  useEffect(() => {
    fetchUsers();
    fetchAccounts();
  }, []);

  const fetchStudents = async (amountType) => {
    if (!amountType) return;

    setIsLoadingStudents(true);
    try {
      // Only for fines, fetch students with their pending months
      const url =
        amountType === "fine"
          ? `${serverUrl}/students_by_type/${center_id}/fine`
          : `${serverUrl}/students_by_type/${center_id}/fee`;

      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch students");
      const data = await response.json();

      if (amountType === "fine") {
        // Group months by student
        const studentMap = {};
        data.data.forEach((item) => {
          if (!studentMap[item.id]) {
            studentMap[item.id] = {
              value: item.id,
              label: item.name,
              pendingMonths: [],
            };
          }
          studentMap[item.id].pendingMonths.push(item.month_formatted);
        });

        const options = Object.values(studentMap);
        setFilteredStudentOptions(options);
      } else {
        // Regular fee students
        const options = data.data.map((item) => ({
          value: item.id,
          label: `${item.name} - ${item.amount}`,
        }));
        setFilteredStudentOptions(options);
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      toast.error("Failed to load students");
      setFilteredStudentOptions([]);
    } finally {
      setIsLoadingStudents(false);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await fetch(`${serverUrl}/user_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch users");
      const data = await response.json();
      setUserOptions(
        data.data.map((item) => ({ value: item.id, label: item.name }))
      );
    } catch (error) {
      console.error(error);
      toast.error("Failed to load users");
    }
  };

  const fetchAccounts = async () => {
    try {
      const response = await fetch(`${serverUrl}/account_ids/${center_id}`);
      if (!response.ok) throw new Error("Failed to fetch accounts");
      const data = await response.json();
      setAccountOptions(
        data.data.map((item) => ({ value: item.id, label: item.name }))
      );
    } catch (error) {
      console.error(error);
      toast.error("Failed to load accounts");
    }
  };
  useEffect(() => {
    if (
      inputValues.amount_type === "fine" &&
      inputValues.selectedStudents.length &&
      inputValues.selectedMonths.length
    ) {
      // Build a description string
      const studentNames = inputValues.selectedStudents
        .map((s) => s.label)
        .join(", ");
      const months = inputValues.selectedMonths.map((m) => m.label).join(", ");
      const desc = `Fine submitted for ${studentNames} for ${months}`;

      setInputValues((prev) => ({ ...prev, description: desc }));
    }
  }, [
    inputValues.amount_type,
    inputValues.selectedStudents,
    inputValues.selectedMonths,
  ]);

  const validateForm = () => {
    if (!file) {
      toast.error("Please upload the fee slip/image");
      return false;
    }

    const requiredFields = [
      "user_id",
      "account_id",
      "amount",
      "amount_type",
      "description",
      "date",
    ];
    if (inputValues.amount_type === "fee") requiredFields.push("student_id");
    if (
      inputValues.amount_type === "fine" &&
      (!inputValues.selectedStudents.length ||
        !inputValues.selectedMonths.length)
    ) {
      toast.error("Select at least one student and month for fine");
      return false;
    }

    const missingFields = requiredFields.filter((field) => !inputValues[field]);
    if (missingFields.length) {
      toast.error(
        `Please fill in all required fields: ${missingFields.join(", ")}`
      );
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form first
    if (!validateForm()) return;

    // Open confirmation dialog instead of submitting directly
    setOpenConfirmDialog(true);
  };

  const handleConfirmSubmit = async () => {
    // Close the dialog
    setOpenConfirmDialog(false);

    const formData = new FormData();
    formData.append("center_id", center_id);
    if (inputValues.amount_type === "fee")
      formData.append("student_id", inputValues.student_id);
    else {
      formData.append(
        "student_ids",
        JSON.stringify(inputValues.selectedStudents.map((s) => s.value))
      );
      formData.append(
        "months",
        JSON.stringify(inputValues.selectedMonths.map((m) => m.value))
      );
    }
    formData.append("user_id", inputValues.user_id);
    formData.append("account_id", inputValues.account_id);
    formData.append("amount", inputValues.amount);
    formData.append("amount_type", inputValues.amount_type);
    formData.append("description", inputValues.description);
    formData.append("date", inputValues.date);
    formData.append("status", inputValues.status || 1);
    formData.append("logo", file);

    const toastId = toast.loading("Adding new fee receipt...");
    try {
      const response = await fetch(`${serverUrl}/add_feesform`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.code >= 400)
        toast.update(toastId, {
          render: data.message || "Failed to add fee receipt",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      else {
        toast.update(toastId, {
          render: "Fee receipt added successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
        setInputValues({
          amount_type: "",
          student_id: null,
          selectedStudents: [],
          selectedMonths: [],
          amount: "",
          user_id: null,
          account_id: null,
          description: "",
          date: "",
          status: 1,
        });
        setFile(null);
        setFilePreview("");
        setFilteredStudentOptions([]);
        setTimeout(() => navigate("/fees-form"), 1500);
      }
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: "Error occurred while adding fee receipt",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  const handleCancelSubmit = () => {
    // Just close the dialog without submitting
    setOpenConfirmDialog(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" autoClose={3000} />
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      {/* File Upload */}
                      <Grid item xs={12}>
                        <FilePreviewContainer
                          className={dragActive ? "drag-active" : ""}
                          onDragEnter={handleDrag}
                          onDragOver={handleDrag}
                          onDragLeave={handleDrag}
                          onDrop={handleDrop}
                        >
                          {filePreview ? (
                            <>
                              <PreviewImage
                                src={filePreview}
                                alt="Fee Slip Preview"
                              />
                              {file && (
                                <>
                                  <FileInfo>
                                    <div className="fileName">{file.name}</div>
                                    <div className="fileSize">
                                      {(file.size / 1024).toFixed(1)} KB
                                    </div>
                                  </FileInfo>
                                  <RemoveButton
                                    variant="contained"
                                    color="error"
                                    onClick={handleRemoveFile}
                                  >
                                    ×
                                  </RemoveButton>
                                </>
                              )}
                            </>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                p: 2,
                              }}
                            >
                              <CloudUploadIcon
                                sx={{
                                  fontSize: 48,
                                  color: dragActive ? "#7451f8" : "#bdbdbd",
                                  mb: 1,
                                  transition: "color 0.3s",
                                }}
                              />
                              <Typography variant="body1" color="textSecondary">
                                {dragActive
                                  ? "Drop your fee slip here"
                                  : "Drag & drop your fee slip here or"}
                              </Typography>
                              <Button
                                component="label"
                                variant="outlined"
                                startIcon={<DriveFolderUploadOutlinedIcon />}
                                sx={{ mt: 2 }}
                              >
                                Browse Files
                                <VisuallyHiddenInput
                                  type="file"
                                  accept="image/*,.pdf"
                                  onChange={handleFileChange}
                                  required
                                />
                              </Button>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                sx={{ mt: 1 }}
                              >
                                (Supports JPG, PNG, PDF up to 5MB)
                              </Typography>
                            </Box>
                          )}
                        </FilePreviewContainer>
                      </Grid>

                      {/* Amount Type */}
                      <Grid item xs={12} sm={6}>
                        <div className="formInput">
                          <label>Amount Type *</label>
                          <StyledSelect
                            options={AmountTypeOptions}
                            name="amount_type"
                            onChange={handleAmountTypeSelectChange}
                            value={
                              AmountTypeOptions.find(
                                (option) =>
                                  option.value === inputValues.amount_type
                              ) || null
                            }
                            required
                            classNamePrefix="select"
                            placeholder="Select amount type"
                          />
                        </div>
                      </Grid>

                      {/* Student Selection */}
                      {inputValues.amount_type && (
                        <Grid item xs={12} sm={6}>
                          <div className="formInput">
                            <label>
                              Student
                              {inputValues.amount_type === "fine" ? "s" : ""} *
                            </label>
                            {isLoadingStudents ? (
                              <div>Loading students...</div>
                            ) : filteredStudentOptions.length > 0 ? (
                              <StyledSelect
                                options={filteredStudentOptions}
                                name="student_id"
                                onChange={handleStudentSelectChange}
                                value={inputValues.selectedStudents}
                                required
                                classNamePrefix="select"
                                placeholder={`Select student${
                                  inputValues.amount_type === "fine" ? "s" : ""
                                }`}
                                isMulti={inputValues.amount_type === "fine"}
                              />
                            ) : (
                              <div>No students available for this type</div>
                            )}
                          </div>
                        </Grid>
                      )}

                      {/* Month Selector for Fine */}
                      {inputValues.amount_type === "fine" &&
                        inputValues.selectedStudents.length > 0 && (
                          <Grid item xs={12} sm={6}>
                            <div className="formInput">
                              <label>Select Month(s) *</label>
                              <StyledSelect
                                options={inputValues.selectedStudents.flatMap(
                                  (student) =>
                                    student.pendingMonths.map((month) => ({
                                      value: month,
                                      label: month + ` (${student.label})`,
                                    }))
                                )}
                                value={inputValues.selectedMonths}
                                onChange={handleMonthSelectChange}
                                isMulti
                                placeholder="Select month(s)"
                                classNamePrefix="select"
                              />
                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                Amount is calculated as 500 per month
                              </Typography>
                            </div>
                          </Grid>
                        )}

                      {/* User */}
                      <Grid item xs={12} sm={6}>
                        <div className="formInput">
                          <label>User *</label>
                          <StyledSelect
                            options={userOptions}
                            name="user_id"
                            onChange={handleUserSelectChange}
                            value={
                              userOptions.find(
                                (option) => option.value === inputValues.user_id
                              ) || null
                            }
                            required
                            classNamePrefix="select"
                            placeholder="Select user"
                          />
                        </div>
                      </Grid>

                      {/* Account */}
                      <Grid item xs={12} sm={6}>
                        <div className="formInput">
                          <label>Account *</label>
                          <StyledSelect
                            options={accountOptions}
                            name="account_id"
                            onChange={handleAccountSelectChange}
                            value={
                              accountOptions.find(
                                (option) =>
                                  option.value === inputValues.account_id
                              ) || null
                            }
                            required
                            classNamePrefix="select"
                            placeholder="Select account"
                          />
                        </div>
                      </Grid>

                      {/* Amount */}
                      <Grid item xs={12} sm={6}>
                        <div className="formInput">
                          <label>Amount *</label>
                          <input
                            type="number"
                            name="amount"
                            value={inputValues.amount}
                            onChange={handleInputChange}
                            placeholder="Enter amount"
                            required
                          />
                        </div>
                      </Grid>

                      {/* Description */}
                      <Grid item xs={12} sm={6}>
                        <div className="formInput">
                          <label>Description *</label>
                          <input
                            type="text"
                            name="description"
                            value={inputValues.description}
                            onChange={handleInputChange}
                            placeholder="Enter description"
                            required
                          />
                        </div>
                      </Grid>

                      {/* Date */}
                      <Grid item xs={12} sm={6}>
                        <div className="formInput">
                          <label>Date *</label>
                          <input
                            type="date"
                            name="date"
                            value={inputValues.date}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </Grid>

                      {/* Status */}
                      {/* <Grid item xs={12} sm={6}>
                        <div className="formInput">
                          <label>Status *</label>
                          <StyledSelect
                            options={StatusOptions}
                            name="status"
                            onChange={handleStatusSelectChange}
                            value={
                              StatusOptions.find(
                                (option) => option.value === inputValues.status
                              ) || StatusOptions[0]
                            }
                            classNamePrefix="select"
                          />
                        </div>
                      </Grid> */}

                      <Grid item xs={12}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          fullWidth
                        >
                          Submit
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Dialog */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCancelSubmit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Submission"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure that the data you entered is correct?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelSubmit} color="secondary">
            No
          </Button>
          <Button onClick={handleConfirmSubmit} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default FeesFormNew;
